import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { motion } from 'framer-motion';
import { GlassWater, Utensils, Wind, Clock, Sparkles, Zap, ArrowRight, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Dining() {
  const happyHourSpecials = [{
    title: 'Craft Cocktails',
    price: '$8',
    description: 'Signature selections from our expert mixologists.',
    icon: GlassWater
  }, {
    title: 'Premium Hookah',
    price: '$25',
    description: 'All premium flavors available during happy hour sessions.',
    icon: Wind
  }, {
    title: 'Small Plates',
    price: '50% OFF',
    description: 'Select appetizers and lounge favorites from our kitchen.',
    icon: Utensils
  }];
  const featuredEntrees = [{
    name: 'Suya & Jollof Rice',
    price: '$28.00',
    desc: 'Smoky, spice-rubbed suya grilled to perfection and served over vibrant, tomato-rich jollof rice.',
    image: 'https://cdn.magicpatterns.com/uploads/4VF1SQyCkvagqQJKhksdhn/pexels-keesha-s-kitchen-22731136-13915043.jpg'
  }, {
    name: 'Signature Smash Burger',
    price: '$17.50',
    desc: 'Double-smashed beef patties with caramelized edges, layered with melted cheese, fresh lettuce, and ripe tomato.',
    image: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?auto=format&fit=crop&q=80&w=800'
  }, {
    name: 'Oxtail Egg Rolls',
    price: '$22.50',
    desc: 'Slow-braised oxtail wrapped and fried, served with HOF signature dipping sauce.',
    image: 'https://cdn.magicpatterns.com/uploads/3X4qBGPmk73NnRQUUkMoxB/image.png'
  }];
  return <div className="min-h-screen bg-[#0B1014] text-white selection:bg-[#DDA247] selection:text-[#0B1014]" data-id="element-1242">
      <Header data-id="element-1243" />

      <main className="pt-24 md:pt-44 pb-16" data-id="element-1244">
        {/* Hero Section */}
        <section className="container mx-auto px-6 mb-16" data-id="element-1245">
          <div className="relative h-[500px] md:h-[650px] rounded-3xl overflow-hidden" data-id="element-1246">
            <img src="https://cdn.magicpatterns.com/uploads/fwgdVVWY6w4ZNzLwaN8pQF/SnapInsta.to_682684463_18095297435328170_2923975602234658742_n.jpg" alt="Dining at House of Flavors" className="absolute inset-0 w-full h-full object-cover" data-id="element-1247" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B1014] via-[#0B1014]/40 to-transparent" data-id="element-1248" />

            <div className="absolute inset-0 flex flex-col justify-center p-8 md:p-16" data-id="element-1249">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6
            }} data-id="element-1250">
                <div className="flex flex-wrap items-center gap-3 mb-6" data-id="element-1251">
                  <span className="px-4 py-1 bg-[#DDA247] text-[#0B1014] font-black text-xs uppercase tracking-widest" data-id="element-1252">
                    Dinner • 5PM - Late
                  </span>
                  <span className="px-4 py-1 bg-white/10 text-white font-black text-xs uppercase tracking-widest backdrop-blur-md" data-id="element-1253">
                    Happy Hour • 5PM - 8PM
                  </span>
                </div>
                <h1 className="text-4xl md:text-6xl font-black text-white mb-6 uppercase tracking-tight leading-none" data-id="element-1254">
                  The <span className="text-[#DDA247]" data-id="element-1255">Dining</span> Experience
                </h1>
                <p className="text-lg md:text-xl text-gray-200 max-w-2xl mb-10 leading-relaxed" data-id="element-1256">
                  Experience bold flavors and artisanal techniques. From our
                  signature suya to handcrafted cocktails, we bring a
                  sophisticated touch to every plate.
                </p>
                <div className="flex flex-col sm:flex-row gap-4" data-id="element-1257">
                  <Link to="/book-now" data-id="element-1258">
                    <Button size="lg" className="min-w-[220px]" data-id="element-1259">
                      Reserve a Table
                    </Button>
                  </Link>
                  <Link to="/menu" data-id="element-1260">
                    <Button variant="outline" size="lg" className="min-w-[220px]" data-id="element-1261">
                      View Full Menu
                    </Button>
                  </Link>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Happy Hour Section */}
        <section className="container mx-auto px-6 mb-24" data-id="element-1262">
          <div className="flex flex-col md:flex-row items-end justify-between mb-12 gap-6" data-id="element-1263">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-1264">
              <p className="text-[#DDA247] font-bold uppercase tracking-[0.3em] text-sm mb-3" data-id="element-1265">
                The Social Hour
              </p>
              <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tight" data-id="element-1266">
                Happy <span className="text-[#DDA247]" data-id="element-1267">Hour</span>
              </h2>
              <p className="text-gray-400 mt-4 max-w-xl" data-id="element-1268">
                Available daily from 5 PM – 8 PM. Join us for premium spirits
                and elite small plates at exceptional prices.
              </p>
            </motion.div>
            <div className="flex items-center gap-2 px-6 py-3 bg-white/5 border border-white/10 rounded-full" data-id="element-1269">
              <Clock className="text-[#DDA247] w-5 h-5" data-id="element-1270" />
              <span className="font-bold uppercase tracking-widest text-sm" data-id="element-1271">
                5:00 PM - 8:00 PM
              </span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1272">
            {happyHourSpecials.map((special, index) => <motion.div key={special.title} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.6
          }} className="bg-[#11161A] border border-white/5 p-10 rounded-2xl relative overflow-hidden group hover:border-[#DDA247]/30 transition-colors duration-300" data-id="element-1273">
                <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-1274">
                  <special.icon size={120} data-id="element-1275" />
                </div>
                <h3 className="text-xl font-black text-[#DDA247] mb-2 uppercase tracking-widest" data-id="element-1276">
                  {special.title}
                </h3>
                <p className="text-4xl font-black text-white mb-4" data-id="element-1277">
                  {special.price}
                </p>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1278">
                  {special.description}
                </p>
              </motion.div>)}
          </div>
        </section>

        {/* Featured Entrees */}
        <section className="container mx-auto px-6 mb-24" data-id="element-1279">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-1280">
            <p className="text-[#DDA247] font-bold uppercase tracking-[0.3em] text-sm mb-3" data-id="element-1281">
              Chef's Selection
            </p>
            <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tight" data-id="element-1282">
              Signature <span className="text-[#DDA247]" data-id="element-1283">Entrées</span>
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1284">
            {featuredEntrees.map((item, index) => <motion.div key={item.name} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="group bg-[#11161A] rounded-2xl overflow-hidden border border-white/5 hover:border-[#DDA247]/30 transition-all duration-500" data-id="element-1285">
                <div className="h-64 overflow-hidden" data-id="element-1286">
                  <img src={item.image} alt={item.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-1287" />
                </div>
                <div className="p-8" data-id="element-1288">
                  <div className="flex justify-between items-start mb-4" data-id="element-1289">
                    <h3 className="text-xl font-bold text-white group-hover:text-[#DDA247] transition-colors" data-id="element-1290">
                      {item.name}
                    </h3>
                    <span className="text-[#DDA247] font-bold" data-id="element-1291">
                      {item.price}
                    </span>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-1292">
                    {item.desc}
                  </p>
                  <Link to="/menu" className="inline-flex items-center gap-2 text-[#DDA247] font-bold text-xs uppercase tracking-widest hover:text-white transition-colors" data-id="element-1293">
                    Order Now <ArrowRight size={14} data-id="element-1294" />
                  </Link>
                </div>
              </motion.div>)}
          </div>

          <div className="mt-16 text-center" data-id="element-1295">
            <Link to="/menu" data-id="element-1296">
              <Button variant="outline" size="lg" className="group" data-id="element-1297">
                Explore Full Menu
                <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-1298" />
              </Button>
            </Link>
          </div>
        </section>

        {/* Atmosphere Section */}
        <section className="container mx-auto px-6" data-id="element-1299">
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-[#11161A] border border-white/5 rounded-3xl overflow-hidden" data-id="element-1300">
            <div className="grid grid-cols-1 lg:grid-cols-2 items-center" data-id="element-1301">
              <div className="p-8 md:p-16" data-id="element-1302">
                <h2 className="text-4xl font-bold mb-8 uppercase tracking-tight" data-id="element-1303">
                  The <span className="text-[#DDA247]" data-id="element-1304">Atmosphere</span>
                </h2>
                <p className="text-gray-400 text-lg mb-10 leading-relaxed" data-id="element-1305">
                  Our dining room is designed for those who appreciate refined
                  leisure. Whether you're unwinding after work or starting your
                  evening early, our immersive visual canvas and curated
                  soundscapes provide the perfect backdrop.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-1306">
                  <div className="space-y-2" data-id="element-1307">
                    <h4 className="text-white font-bold uppercase text-sm tracking-widest" data-id="element-1308">
                      Immersive Visuals
                    </h4>
                    <p className="text-gray-500 text-xs leading-relaxed" data-id="element-1309">
                      Our 190ft video wall sets a sophisticated mood for your
                      dining experience.
                    </p>
                  </div>
                  <div className="space-y-2" data-id="element-1310">
                    <h4 className="text-white font-bold uppercase text-sm tracking-widest" data-id="element-1311">
                      Curated Playlists
                    </h4>
                    <p className="text-gray-500 text-xs leading-relaxed" data-id="element-1312">
                      Smooth R&B and chill house to transition your day into the
                      night.
                    </p>
                  </div>
                </div>
                <div className="mt-12 flex items-center gap-6" data-id="element-1313">
                  <div className="flex items-center gap-2" data-id="element-1314">
                    <Clock className="text-[#DDA247]" size={20} data-id="element-1315" />
                    <span className="text-white font-bold text-sm uppercase tracking-widest" data-id="element-1316">
                      5PM - Late
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1317">
                    <Star className="text-[#DDA247]" size={20} data-id="element-1318" />
                    <span className="text-white font-bold text-sm uppercase tracking-widest" data-id="element-1319">
                      Daily
                    </span>
                  </div>
                </div>
              </div>
              <div className="relative h-full min-h-[500px]" data-id="element-1320">
                <img src="https://cdn.magicpatterns.com/uploads/mNTFqmsMdHbfPctSPfK7sR/HOF_18.jpg" alt="Dining Atmosphere" className="absolute inset-0 w-full h-full object-cover" data-id="element-1321" />
                <div className="absolute inset-0 bg-gradient-to-r from-[#11161A] to-transparent lg:block hidden" data-id="element-1322" />
              </div>
            </div>
          </motion.div>
        </section>
      </main>

      <Footer data-id="element-1323" />
    </div>;
}